import { Env } from '@env';
import { useEffect, useState } from 'react';
import { Platform } from 'react-native';

function useGoogleMapsApi() {
  const [isApiLoaded, setApiLoaded] = useState(false);

  useEffect(() => {
    const loadGoogleMapsApi = () => {
      if (!window.google) {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${Env.GOOGLE_WEB_API_KEY}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.addEventListener('load', () => {
          // The Google Maps API has been loaded and is now available
          setApiLoaded(true);
        });
        document.body.appendChild(script);
      } else {
        setApiLoaded(true);
      }
    };

    if (Platform.OS !== 'web') return;

    loadGoogleMapsApi();
  }, []);

  if (Platform.OS !== 'web') return true;

  return isApiLoaded;
}

export default useGoogleMapsApi;
